module.exports = __webpack_public_path__ + "static/media/delete-white.2580d4eb.svg";